module.exports = __webpack_public_path__ + "static/media/ATRSaaSIcon.adcca28e.svg";